export default {
  events: {
    esc: null, // 'closePreview',
    'command i': null, // toggle infopanel
    'command h': null, // toggle historypanel
  },
};
